module.exports = __webpack_public_path__ + "static/img/copy_n.09f5554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/copy_n.png
// module id = crwK
// module chunks = 24